import { BffConfigSchema } from "@omni/schemas/config/bffConfig.schema";
import { ComponentsConfigSchema } from "@omni/schemas/config/componentsConfig.schema";
import { ContractsConfigSchema } from "@omni/schemas/config/contractsConfig.schema";
import { SsrConfigSchema } from "@omni/schemas/config/ssrConfig.schema";
import { ConfigType } from "@omni/types/enums/configType.enum";
import * as yup from "yup";

import * as ConfigProvider from "./configProvider";

export const Schemas = {
    [ConfigType.Ssr]: SsrConfigSchema,
    [ConfigType.Bff]: BffConfigSchema,
    [ConfigType.Components]: ComponentsConfigSchema,
    [ConfigType.Contracts]: ContractsConfigSchema
} as const;

export const getConfig = <K extends ConfigType>(
    type: K
): yup.InferType<(typeof Schemas)[K]> => {
    return Schemas[type].validateSync(ConfigProvider.getProvider(type)(), {
        stripUnknown: true
    });
};
